import Link from "next/link";

const BlogHeader = ({ blogs }) => {
  return (
    blogs &&
    blogs[0] && (
      <div className="position-relative blogBanner">
        <img
          src={blogs[0].headerImage && blogs[0].headerImage[0].image}
          className="w-100"
          alt={blogs[0].headerImage && blogs[0].headerImage[0].name}
        />
        <div className="imageOverlay">
          <div className="fo-52 fw-600 text-center mfo-20">
            {blogs[0].title}
          </div>
          <div className="text-center mt-3 mt-md-5">
            <Link href={"/blogs/" + blogs[0].slug} rel="noreferrer">
              <button className="btn showMoreButton">READ MORE</button>
            </Link>
          </div>
        </div>
      </div>
    )
  );
};

export default BlogHeader;
